import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=ef62a514&scoped=true"
var script = {}
import style0 from "./Default.vue?vue&type=style&index=0&id=ef62a514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_21fabc512e5cf77502f11efea17f021f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef62a514",
  null
  
)

export default component.exports